angular.module("App.video.list", ["App.video.service", "jv.Common.EmployeeSelect", "jv.Common.Directives.fallbackImage"])
    .config(['$provide',
        function($provide) {
            $provide.decorator('url', function() {
                return '/admin/action/user/search?';
                //return '/jhire/action/requisitionDetails?';
            });
        }
    ]);
